import { Center, Loader } from '@mantine/core'
import { Navigate, Route, Routes } from 'react-router-dom'

import { AuthProvider, useAuth } from './auth/AuthContext'
import { Shell } from './components/Shell'
import { BomDetailPage } from './pages/BomDetail'
import { BomListPage } from './pages/BomList'
import { CatalogPage } from './pages/Catalog'
import { CustomersPage } from './pages/Customers'
import { InventoryPage } from './pages/Inventory'
import { OrderDetailPage, OrdersPage } from './pages/Orders'
import { ReplacementPlanEditorPage } from './pages/ReplacementPlanEditor'
import { SettingsPage } from './pages/Settings'
import { LoginPage } from './pages/Login'

/**
 * Route guard.
 *
 * Cosmetic, like the rest of the role handling: it stops an unauthenticated
 * visitor from staring at empty panels, but the server refuses every request
 * regardless. A client-side guard has never protected anything and this one
 * is not an exception.
 */
function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <Center mih="100vh">
        <Loader />
      </Center>
    )
  }
  if (!user) return <LoginPage />
  return <>{children}</>
}

function Routing() {
  return (
    <Routes>
      <Route
        element={
          <Protected>
            <Shell />
          </Protected>
        }
      >
        <Route index element={<Navigate to="/catalog" replace />} />
        <Route path="/catalog" element={<CatalogPage />} />
        <Route path="/bom" element={<BomListPage />} />
        <Route path="/bom/:id" element={<BomDetailPage />} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/inventory/plans/:id" element={<ReplacementPlanEditorPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/:id" element={<OrderDetailPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/catalog" replace />} />
      </Route>
    </Routes>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <Routing />
    </AuthProvider>
  )
}
